<span [class.notification]="showNotification()">{{ data?.toString() | date: column?.format }}</span>
